export default __webpack_public_path__ + "static/media/AntyLucy_12.20bc0f29.jpg";